import React from "react";

import ForgotPasswordContainer from '../components/ForgotPasswordForm'
import AuthLayout from '../layouts/AuthLayout';
import { useTranslation } from "react-i18next";


function LoginPage() {
    const { t } = useTranslation('common')
    return (
        <AuthLayout title={t('auth.forgotPasswordTitle')}>
            <ForgotPasswordContainer />
        </AuthLayout>
    );
}

export default LoginPage;